import React from 'react';
import './style.scss'
import {ReactComponent as Logo} from "./Vieunite_logo_Pro_Logo.svg";

const ProHeader = (props) => {
    return (
        <div className={'tou'}>
            <div className={'top-blue-bar'}>
                <a href="/home" className="tab">For Home</a>
                <a href="/business" className="tab tab-active">For Business</a>
            </div>
            <div className={'pro-header'}>
                <div className={'logo'}
                     onClick={() => window.location.href = "/business/home"}
                     style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <Logo/>
                </div>
                <div>
                    <ul className={'pro-menu'}
                        style={{margin: '5px 0 0 -8rem', columnGap: '3rem'}}>
                        <li>
                            <a href="/business/home" className={"hover-underline-animation jing-header-h"}
                               style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}>
                                Home
                            </a>
                        </li>
                        <li>
                            <a href="/business/textura-pro" className={"hover-underline-animation jing-header-h"}
                               style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}>
                                Textura Pro
                            </a>
                        </li>
                        <li>
                            <a href="/business/subscription" className={"hover-underline-animation jing-header-h"}
                               style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}>
                                Subscription
                            </a>
                        </li>
                        <li>
                            <a href="/business/software" className={"hover-underline-animation jing-header-h"}
                               style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}>
                                Software
                            </a>
                        </li>
                        <li>
                            <a href="/business/curated-collections" className={"hover-underline-animation jing-header-h"}
                               style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}>
                                Curated Collections
                            </a>
                        </li>
                    </ul>
                </div>
                <div className={'logo'}>
                    <a href="/business/prologin" className={"hover-underline-animation"}
                       style={{color: "black", fontWeight: '600', fontSize: '0.9vw'}}
                    >
                        Login
                    </a>
                </div>
            </div>
        </div>
    )
}

export default ProHeader;
